import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { EMPTY_STRING } from '@modeso/aumico-lib-core-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { pairwise, startWith } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'extra-settings',
    templateUrl: './extra-settings.component.html',
    styleUrls: ['./extra-settings.component.scss'],
})
export class ExtraSettingsComponent implements OnInit {
    @Input() checked: boolean;
    @Input() hideTotalToggle: boolean;
    @Input() hideReference = false;
    @Input() title: string;

    @Input() addNumbering: boolean;
    @Input() titleControl: FormControl<string>;

    @Output() onToggleChange = new EventEmitter<boolean>();
    @Output() onTitleChange = new EventEmitter<string>();
    @Output() onOpenReferenceDialog = new EventEmitter<void>();
    @Output() onAddNumberToggleEmit = new EventEmitter<boolean>();

    constructor() {}
    ngOnInit(): void {
        if (!this.titleControl) {
            this.titleControl = new FormControl<string>('');
        }

        this.titleControl.setValue(this.title ?? EMPTY_STRING);

        if (this.title) {
            this.onAddNumberToggleChange(true);
        }

        this.titleControl.valueChanges
            .pipe(startWith(this.title), pairwise(), untilDestroyed(this))
            .subscribe(([prevValue, currentValue]) => {
                const title = currentValue.trim();
                if (title === EMPTY_STRING) {
                    this.onAddNumberToggleChange(false);
                }
                if (currentValue != null && !prevValue) {
                    this.onAddNumberToggleChange(true);
                }
                this.onTitleChange.emit(title);
            });
    }

    toggleChange(checked: boolean): void {
        this.onToggleChange.emit(checked);
    }

    openReferenceDialog(): void {
        this.onOpenReferenceDialog.emit();
    }

    onAddNumberToggleChange(checked: boolean): void {
        this.onAddNumberToggleEmit.emit(checked);
    }
}
